import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private audio: HTMLAudioElement;

  constructor() {
    this.audio = new Audio('assets/images/Fire_alarm_sound.mp3');
    this.audio.load();
  }

  playAlarmSound(): void {
    this.audio.currentTime = 0;
    this.audio.play().catch(error => {
      console.error('Error playing alarm sound:', error);
    });
  }
}
